import { FileXls } from '@phosphor-icons/react';

export default FileXls;
